import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppStore from '../../stores/AppStore';
import $ from 'jquery';
import _get from 'lodash/get';
import * as FPT from '../../utility/fpt';

import { localsMessages } from '../../utility/getTemplateData';
let threeDSText = localsMessages('common/threeDSecure');

class ThreeDSIframe extends Component {
	shouldComponentUpdate(nextProps, nextState) {
		return false;
	}

	componentDidMount() {
		this.onModalShown();
		this.onModalHidden();
		this.showModal();
		this.addEventListener();
		
		const threeDSRespDuration = {
			challenge_start_time: new Date().getTime()
		}
		FPT.add3DSRespDuration(threeDSRespDuration, window.fpti.pgrp, window.fpti.page);
	}

	componentWillUnmount() {
		$('#three-ds2-iframe').off('shown.bs.modal');
		$('#three-ds2-iframe').off('hidden.bs.modal');
		window.removeEventListener('message', this.handleIframeMessage);
	}

	showModal = () => {
		$('#three-ds2-iframe').modal('show');
	}

	hideModal = () => {
		$('#three-ds2-iframe').modal('hide');
	}

	onModalShown = () => {
		$('#three-ds2-iframe').on('shown.bs.modal', () => {
			this.submitForm();
		});
	}

	onModalHidden = () => {
		$('#three-ds2-iframe').on('hidden.bs.modal', () => {
			// @TODO: DO we need this
		});
	}

	addEventListener = () => {
		window.addEventListener('message', this.handleIframeMessage);
	}

	handleIframeMessage = (event) => {
		const source = _get(event, 'data.source');
		const confirmationStatus = _get(event, 'data.confirmationStatus');
		const error = _get(event, 'data.err');

		if (source !== 'paypal') {
			return;
		}
		
		FPT.add3DSChallengeStatus(confirmationStatus);
		FPT.trackError(error);
		const threeDSRespDuration = {
			challenge_end_time: new Date().getTime()
		}
		FPT.add3DSRespDuration(threeDSRespDuration, window.fpti.pgrp, window.fpti.page);

		this.props.onStepUpAuthComplete({
			confirmationStatus,
			error
		});
		this.hideModal();
	}

	setFormRef = (element) => {
		this.formRef = element;
	}

	submitForm = () => {
		setTimeout(() => {
			if (this.formRef) {
				this.formRef.submit()
			}
		}, 100);
	}


	render() {
		const contingency = AppStore.getThreeDSContingency() || {};

		const {
			threeDS2Contingency
		} = contingency;

		const redirectLink = _get(threeDS2Contingency, '3d_secure_redirect_link');
		const jwt = _get(threeDS2Contingency, 'jwt');
		const fundingOptions = AppStore.getFundingOptions();
		const md = fundingOptions.id;
		const redirectMethod = _get(threeDS2Contingency, 'cardinal_redirect_method');

		if (!redirectLink) {
			return null;
		}

		let requestText = _get(threeDSText, 'requestText', 'Enter requested information to confirm your card');

		return (
			<div className="modal fade donate_dialog" data-tabindex="-1" data-role="dialog" id="three-ds2-iframe"
				data-backdrop="static">
				<div className="modal-dialog">
					<div className="modal-content">
						
						<div className="modal-body recurring-modal-body">
							{
								this.props.icon &&
								<div className="text-center">
									<img src={this.props.icon} alt="Icon" />
								</div>
							}
							<div className="modalContent">
								<div className="text-center">
									<div className="container">
										<img src="https://www.paypalobjects.com/webstatic/icon/favicon.ico" />
									</div>
									<div><h3>{requestText}</h3></div>
									<iframe
										title="ThreeDSIframe"
										name="stepUp"
										id="stepUp"
										style={{
											width: '500px',
											height: '640px'
										}}
										frameBorder="0"
									>
										<form
											ref={this.setFormRef}
											name="stepUpForm"
											id="stepUpForm"
											target="stepUp"
											method={redirectMethod}
											action={redirectLink}
										>
											<input type="hidden" name="JWT" value={jwt} />
											<input type="hidden" name="MD" value={md} /> 
										</form>
									</iframe>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

ThreeDSIframe.propTypes = {
	onStepUpAuthComplete: PropTypes.func,
	icon: PropTypes.string
}
export default ThreeDSIframe;



// WEBPACK FOOTER //
// ./components/threeDS/ThreeDSIframe.js